<template>
  <v-container fluid class="tabs-content__container">
    <v-row class="ma-0">
      <v-col cols="12">
        <h1>Campaign Summary</h1>
      </v-col>
      <!--Campaign Details-->
      <v-col cols="12">
        <h3>Campaign Details</h3>
        <v-row>
          <v-col cols="5" md="3">
            <div class="grey--text text--darken-2 pl-3">Campaign type</div>
          </v-col>
          <v-col cols="7" md="9">
            <div>{{ campaign.type.substr(3) }}</div>
          </v-col>
          <v-col cols="5" md="3">
            <div class="grey--text text--darken-2 pl-3">Campaign name</div>
          </v-col>
          <v-col cols="7" md="9">
            <div>{{ campaign.name }}</div>
          </v-col>
          <v-col cols="5" md="3">
            <div class="grey--text text--darken-2 pl-3">Shedule</div>
          </v-col>
          <v-col cols="7" md="9">
            <div>{{ campaign.start_time | formatDate }} - {{ campaign.end_time | formatDate }}</div>
          </v-col>
          <v-col cols="5" md="3">
            <div class="grey--text text--darken-2 pl-3">Budget</div>
          </v-col>
          <v-col cols="7" md="9">
            <div v-if="campaign.selectedBudget === 'lifetime_budget'">${{ budget | thousands }} total</div>
            <div v-else>
              <span> ${{ campaign.daily_budget }} per day / </span>
              <span class="grey--text text--darken-2">${{ budget | thousands }} total</span>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <!--Audiences-->
      <v-col cols="12">
        <h3>Audiences</h3>
        <v-row
        align="center"
        v-for="(item, index) in campaign.selectedAudiences"
        :key="index + 777"
      >
        <v-col cols="5" md="3">
          <div class="grey--text text--darken-2 pl-3">{{ item.name | titleCase }}</div>
        </v-col>
        <v-col cols="7" md="9" v-if="isArray(item.value)">
          <span class="audiences"
            v-for="(name, i) in item.value"
           :key="i"
          >{{ name }}</span>
        </v-col>
        <v-col v-else>
          <span>{{ item.value }}</span>
        </v-col>
      </v-row>
      </v-col>
      <!--Geo-->
      <v-col cols="12">
        <h3>Geo</h3>
        <v-col cols="12" md="9" offset-md="3">
          <span>{{ campaign.selectedGeo | formatGeo }}</span>
        </v-col>
      </v-col>
      <!--Issues and Messages-->
      <v-col cols="12">
        <h3>Issues and Messages</h3>
        <v-row
          v-for="issue in campaign.issues"
          :key="issue.id"
        >
          <v-col cols="12">
            <div class="grey--text text--darken-2 pl-3">{{ issue.name }}</div>
          </v-col>
          <v-col cols="12" md="9" offset-md="3">
            <v-card
              width="90px"
              height="94px"
              class="overflow-hidden"
              v-for="message in getRelatedMessages(issue.name)"
              :key="message.id"
            >
              <img
                v-if="message.selectedVideo"
                :src="message.selectedVideo.picture"
                height="50px"
                width="100%"
                class="cover"
              />
              <img
                v-else-if="message.reviewFileUrl"
                :src="message.reviewFileUrl"
                height="50px"
                width="100%"
                class="cover"
              />
              <img
                v-else-if="message.externalUrl"
                :src="message.externalUrl"
                height="50px"
                width="100%"
                class="cover"
              />
              <img
                v-else
                src="https://app.outfox.ai/static/img/of-logo.ba20680.png"
                height="50px"
                width="100%"
                class="cover"
              />
              <v-card-text
                class="px-2 py-0"
              >
                <div class="font-size-small font-weight-bold">{{ message.headline }}</div>
                <span class="font-size-small">{{ message.text }}</span>
              </v-card-text>
            </v-card>
            <div v-if="!getRelatedMessages(issue.name).length">No created messages</div>
          </v-col>
        </v-row>
      </v-col>
      <!--Success Metrics-->
      <v-col cols="12">
        <v-row>
          <v-col cols="5" md="3">
            <h3>Success Metrics</h3>
          </v-col>
          <v-col cols="7" md="6">
            <span>{{ formatObjective(campaign.objective) | titleCase }}</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div class="tabs-content__container-action">
      <v-row>
        <v-btn @click="previousPage">Previous</v-btn>
        <v-spacer />
        <v-btn
          color="info"
          @click="addCampaign"
        >
          Save & Launch
        </v-btn>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
export default {
  name: 'campaign-summary',
  data () {
    return {}
  },
  props: {
    campaign: {
      type: Object,
      default: () => {}
    },
    editCampaign: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    messages () {
      return this.$store.getters.getMessages
    },
    budget () {
      if (this.campaign.selectedBudget === 'lifetime_budget') return this.campaign.lifetime_budget
      const days = this.$moment(this.campaign.end_time).diff(this.$moment(this.campaign.start_time), 'days')
      return this.campaign.daily_budget * days
    }
  },
  filters: {
    titleCase (str) {
      return str.replace(
          /\w\S*/g,
          function (txt) {
              return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
          }
      )
    },
    formatDate (date) {
      return moment(date).format('MMM DD')
    },
    thousands (number) {
      return Number(number).toLocaleString()
    },
    formatGeo (geo) {
      switch (geo) {
        case 'electoral_districts':
          return 'My district'
        case 'regions':
          return 'My state'
        case 'countries':
          return 'Nationwide'
        case 'zips':
          return 'Saved Locations'
      }
    }
  },
  methods: {
    formatObjective (objective) {
      switch (objective) {
        case 'LINK_CLICKS':
          return 'Traffic'
        case 'POST_ENGAGEMENT':
          return 'Post engagement'
        case 'VIDEO_VIEWS':
          return 'Video views'
        default:
          return objective
      }
    },
    isArray (item) {
      return Array.isArray(item)
    },
    getRelatedMessages (issue) {
      return this.campaign.messages.filter(m => m.issue === issue)
    },
    validation () {
      if (!this.campaign.targeting) {
        this.$store.dispatch('showNotification', {
          type: 'warning',
          message: ['<div>Please select an audience</div>']
        })
        return false
      }
      return true
    },
    addCampaign () {
      if (!this.validation()) return false
      if (this.editCampaign) {
        this.$store.dispatch('editCampaign', this.campaign)
      } else this.createCampaign(this.campaign)
      this.$router.push('/campaigns')
    },
    previousPage () {
      this.$emit('previous', true)
    },
    ...mapActions([
      'createCampaign'
    ])
  }
}
</script>

<style scoped>
  .container {
    background-color: white;
  }
  .audiences:not(:last-child)::after {
    content: ', ';
  }
</style>
